mutation DeleteManagedMeetingTemplate($input: MeetingDeleteInput!) {
    meetingDelete(input: $input) {
        meeting {
            id
            deletedTime
        }
    }
}
